import { BuilderComponentGroup } from '../types'

export const GlobalsComponents: BuilderComponentGroup = {
  id: 'globals',
  title: 'Globals',
  components: [
    {
      compId: 'header',
      title: 'Header',
      icon: 'web_asset',
      nested: true,
      settings: {
        behavior: {
          visibility: true,
        },
      },
    },
    {
      compId: 'footer',
      title: 'Footer',
      icon: 'border_bottom',
      nested: true,
      settings: {
        behavior: {
          visibility: true,
        },
      },
    },
  ],
}
